import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'lemsar-register-page',
    templateUrl: './register.page.html',
})
export class RegisterPage {
    public type = 'landing';

    public constructor(private router: Router) {}

    public signIn(): void {
        this.router.navigateByUrl('/auth/login');
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/pages/register.page.ts